import { useState } from 'react'

// 1° intenta el SVG local en /public/mp-logo.svg
// 2° si no existe, fallback a Wikipedia (logo oficial libre)
const MP_LOGO_LOCAL = '/mp-logo.svg'
const MP_LOGO_REMOTE = 'https://upload.wikimedia.org/wikipedia/commons/9/93/Mercado_Pago_2024.svg'

/**
 * Badge de confianza: pagos con Mercado Pago + seguridad SSL.
 */
export default function TrustBadge({ variant = 'default' }) {
  if (variant === 'compact') {
    return (
      <div className="trust-compact">
        <span className="trust-compact-lock">🔒</span>
        <span>Pagos con</span>
        <MPLogo height={20} />
      </div>
    )
  }
  if (variant === 'inline') {
    return (
      <div className="trust-inline">
        <span className="trust-inline-lock">🔒</span>
        <MPLogo height={16} />
        <span>· SSL</span>
      </div>
    )
  }
  return (
    <div className="trust-default">
      <div className="trust-default-icon">
        <MPLogo height={42} />
      </div>
      <div className="trust-default-body">
        <div className="trust-default-title">🔒 Pagos 100% seguros con Mercado Pago</div>
        <div className="trust-default-sub">
          Aceptamos tarjetas de crédito y débito, Abitab, RedPagos y transferencia con saldo de Mercado Pago.
          Tus datos viajan con cifrado SSL · Limpack nunca ve los datos de tu tarjeta.
        </div>
      </div>
      <style>{`
        .trust-default {
          display: flex; align-items: center; gap: 16px;
          background: linear-gradient(135deg, #f0fdfa, #ecfeff);
          border: 1px solid #99f6e4;
          border-radius: 14px; padding: 16px 18px;
        }
        .trust-default-icon {
          flex-shrink: 0;
          background: #fff;
          border-radius: 12px;
          padding: 8px 12px;
          border: 1px solid #99f6e4;
          display: flex; align-items: center; justify-content: center;
        }
        .trust-default-body { flex: 1; min-width: 0 }
        .trust-default-title {
          font-size: 14px; font-weight: 800; color: #0f4c4a;
        }
        .trust-default-sub { font-size: 12px; color: #115e59; margin-top: 6px; line-height: 1.5 }

        .trust-compact {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 8px 12px; background: rgba(255,255,255,.06);
          border-radius: 10px; font-size: 11px; color: rgba(255,255,255,.85);
        }
        .trust-compact-lock { font-size: 12px }

        .trust-inline {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 10px; border-radius: 999px;
          background: #f0fdfa; border: 1px solid #99f6e4;
          font-size: 11px; font-weight: 700; color: #115e59;
        }
        .trust-inline-lock { font-size: 11px }
      `}</style>
    </div>
  )
}

/**
 * Logo de Mercado Pago — primero intenta local /mp-logo.svg, después Wikipedia, después texto.
 */
function MPLogo({ height = 24 }) {
  const [src, setSrc] = useState(MP_LOGO_LOCAL)
  const [hideImage, setHideImage] = useState(false)

  function handleError() {
    if (src === MP_LOGO_LOCAL) setSrc(MP_LOGO_REMOTE)
    else setHideImage(true)
  }

  if (hideImage) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        fontWeight: 800, fontSize: height * 0.7, lineHeight: 1,
        color: '#0033A0', textTransform: 'lowercase',
      }}>
        mercado&nbsp;
        <span style={{ background: '#00B1EA', color: '#fff', padding: '2px 6px', borderRadius: 4 }}>pago</span>
      </span>
    )
  }

  return (
    <img
      src={src}
      alt="Mercado Pago"
      style={{ height, width: 'auto', display: 'block', verticalAlign: 'middle' }}
      onError={handleError}
    />
  )
}
